import { mapKeys, snakeCase, camelCase } from 'lodash'


export const getSnakeCaseData = (data) => mapKeys(data, (value, key) => snakeCase(key))

export const getCamelCasedData = (data) => mapKeys(data, (value, key) => camelCase(key))
